import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';
import { TextField } from '@material-ui/core';
import { IObservableValue, observable } from 'mobx';
import { emptyQuestionRequest, QuestionRequest, QuestionType } from '../questionTypes';
import { emptyValidationErrors, isValidationErrors, ValidationErrors } from '../../api/restApi';
import { createPicker } from '../../util/picker';
import { renderRemainingErrors, textFieldErrorProps } from '../../util/formUtils';
import { isValidTextQuestion } from '../../util/validations';
import { Spinner } from '../../spinner/Spinner';
import { createQuestion } from './questionCatalogueApi';
import { Button } from '@material-ui/core';
import { Save as SaveIcon } from '@material-ui/icons';
import SaveSnackBar from '../../components/SaveSnackBar';

interface Props {
  renderSearch: (showSearch: boolean) => void;
}

type LocalStyles = 'previewArea';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({

  previewArea: {
    padding: theme.spacing.unit * 2,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class CreateTextQuestion extends React.Component<PropsWithStyle, {}> {

  @observable private newQuestion: QuestionRequest = emptyQuestionRequest();
  @observable private validationErrors: ValidationErrors = emptyValidationErrors();
  private loading: IObservableValue<boolean> = observable.box(false);
  private displaySnackbar: IObservableValue<boolean> = observable.box(false);

  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(false);

    this.newQuestion.questionType = QuestionType.TEXT;
    this.onSave = this.onSave.bind(this);
  }

  public render() {
    const errorPicker = createPicker(this.validationErrors.fieldErrors);
    return (
      <>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <div style={{width: '100%', textAlign: 'right'}}>
                <div>
                  <Button onClick={this.onSave}><SaveIcon/> {translation.t('actions.save')}</Button>
                </div>
              </div>
              <TextField
                type={'text'}
                label={translation.t('question.this')}
                fullWidth={true}
                required={true}
                value={this.newQuestion.question}
                onChange={ev => this.newQuestion.question = ev.target.value.toString()}
                {...textFieldErrorProps(errorPicker.pick(e => e.field === 'question'))}
              />
              <TextField
                type={'text'}
                label={translation.t('module.description')}
                multiline={true}
                fullWidth={true}
                value={this.newQuestion.description}
                onChange={ev => {
                  this.newQuestion.description = ev.target.value
                }}
              />
              {renderRemainingErrors(errorPicker.remaining())}
            </>
        }
        <SaveSnackBar onClose={() => this.displaySnackbar.set(false)} open={this.displaySnackbar.get()}
                      massage={translation.t('questionTab.saved')}/>
      </>
    );
  }

  private onSave() {
    this.validationErrors = isValidTextQuestion(this.newQuestion);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.loading.set(true);
      createQuestion(this.newQuestion).then(
        data => {
          this.loading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = emptyValidationErrors();
            this.displaySnackbar.set(true);
            this.newQuestion.question = '';
            this.newQuestion.description = '';
          }
        }
      )
    }
  }
}

export default withStyles(localStyles)(CreateTextQuestion);
